<div class="ui-loading-dialog--container text-center">
  <div class="title text-large mb-2">{{ title }}</div>
  <div *ngIf="message" class="message text-medium mb-2">{{ message }}</div>
  <div class="dialog-actions flex justify-content-center mt-10">
    <button
      type="button"
      class="lum-button lum-button--secondary"
      mat-button
      (click)="onClose()"
    >
      <lum-ui-icon
        class="mr-2-5"
        icon="close-circle"
        color="#5563D6"
        width="23"
        height="23"
      ></lum-ui-icon>
      Close
    </button>
  </div>
</div>
